module.exports = __webpack_public_path__ + "static/media/384.3ffa02bf.png";